import { ApolloError } from "@apollo/client";
import { Paper } from "@mui/material";
import { useState } from "react";

import { Shared_FormTemplate_QuestionFragment } from "~/shared/components/FormTemplate/fragments/fragments.generated";

import { FormTemplateQuestionFormInputs } from "../FormTemplateQuestionForm";
import ExpandedQuestionItem from "./ExpandedQuestionItem";
import QuestionItemPreview from "./QuestionItemPreview";

type Props = {
    selectableConditionQuestions: Shared_FormTemplate_QuestionFragment[];
    currentQuestion: Shared_FormTemplate_QuestionFragment;
    onUpdate: (id: string, data: FormTemplateQuestionFormInputs) => Promise<void>;
    onDelete: (id: string) => Promise<void>;
    isUpdateQuestionLoading: boolean;
    isDeleteQuestionLoading: boolean;
    error?: ApolloError;
};

export default function FormTemplateQuestionItem({
    currentQuestion,
    selectableConditionQuestions,
    onUpdate,
    onDelete,
    isUpdateQuestionLoading,
    isDeleteQuestionLoading,
    error,
}: Props) {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const handleSubmit = async (data: FormTemplateQuestionFormInputs) => {
        await onUpdate(currentQuestion.id, data);
        setIsExpanded(false);
    };

    const handleDelete = async () => {
        await onDelete(currentQuestion.id);
        setIsExpanded(false);
    };

    // filtering out current question to avoid self referencing
    const siblingSelectableQuestions = selectableConditionQuestions.filter(q => q.id !== currentQuestion.id);

    return (
        <Paper sx={{ padding: 2, borderStyle: "dotted", borderWidth: 2 }} variant="outlined" key={currentQuestion.id}>
            {isExpanded ? (
                <ExpandedQuestionItem
                    currentQuestion={currentQuestion}
                    siblingSelectableQuestions={siblingSelectableQuestions}
                    onSubmit={handleSubmit}
                    onDelete={handleDelete}
                    onCancel={() => setIsExpanded(false)}
                    isUpdateQuestionLoading={isUpdateQuestionLoading}
                    isDeleteQuestionLoading={isDeleteQuestionLoading}
                    error={error}
                />
            ) : (
                <QuestionItemPreview currentQuestion={currentQuestion} onEditClick={() => setIsExpanded(true)} />
            )}
        </Paper>
    );
}
